import React, { useEffect } from 'react';
import withView from './docAutomation/withView';
import FormButton from '../../library/form/components/FormActionButton2';
import FormLabel from '../../library/form/components/FormLabel';
import FormROValue from '../../library/form/components/FormROValue1';
import FormMenu from '../../library/form/components/FormMenu';
import FormShare from '../../library/form/components/FormShare';

//manage url after following action
//after succesfull save, change the url: update with the document id and reload the composition
//after succesfull del, change the url to search screen
//after successfull print, open the report link
//after successfull next step, switch the url
const DocCompHeader = (props) => {
    const { formObject, deviceInfo } = props;

    // console.log("comp header issue", formObject.viewId);

    const initialiseActions = () => {
        // console.log("comp header issue init action", formObject.viewId, formObject.dataList, props);

        if(formObject.dataList) {
            //pass self as dependent so that each time document is saved the composition can be refreshed
            formObject.initialiseCustomActions(formObject.dataList.actionName, formObject.dataList.actionName);
        }
    }

    useEffect(initialiseActions, [formObject.dataList]);

    // const onSaveSuccess = (action, containerKey, rowKey, headerKey, response) => {
    //     //refresh the entire composition
    //     formJS.refreshDependentForms(action, formObject.viewId, "parent");
    // }

    return (
        <div className="phViewHeading">
            <div className="uiFlexBox15">
                <div className="phTitle">
                    <div className="uiFlexBox15">
                        <FormLabel formObject={formObject} rowKey="" headerKey="menu" action={{ paramName: "docID" }} />
                        <FormROValue format="#" formObject={formObject} rowKey="" headerKey="menu" action={{ paramName: "docID" }}/>
                    </div>
                </div>
            </div>
            <div className="uiFlexBox15">
                <FormButton formObject={formObject} ksc="save" headerKey="menu"
                    starIcon="save"
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    rowKey="" tooltip='Save Changes' confirm="Do you want to Save?"
                    disableToHide={true}
                    customWrapper="div"
                    action={{ actionId: "save", 
                    actionMessage: "PleaseWait",
                    isCompHeader:1, continueSession:1, paramName: "save", actionParam: {}, containerKey:"redirect", refreshMode: "parent" }}
                    className="" text="Save" />
                <FormShare formObject={formObject}
                    customWrapper="div"
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    disableToHide={true}
                    directForSingle="0"
                    rowKey="" tooltip='Share' headerKey='share' 
                    action={{isCompHeader:1}}
                    text="Share" />
                <FormMenu formObject={formObject}
                    customWrapper="div"
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    disableToHide={true}
                    directForSingle="0"
                    rowKey="" tooltip='Print' headerKey='print' starIcon={'print'}
                    className={'uiContentCenter uiButtonAppText2'}
                    action={{isCompHeader:1}}
                    text="Print" />
                <FormButton formObject={formObject} headerKey="menu"
                    rowKey="" starIcon={'delete'} tooltip='Delete'
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    starIconClassName="uiColorNegativeAction"
                    disableToHide={true}
                    customWrapper="div"
                    action={{ actionId: "del", actionMessage: "PleaseWait", isCompHeader:1, paramName: "delete", confirm:"Do you really want to delete this document ?", containerKey:"redirect"}}
                    className="" text="Delete" />
                <FormMenu formObject={formObject}
                    customWrapper="div"
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    disableToHide={true}
                    rowKey="" tooltip='Next Actions Supported by this Document' headerKey='nextAction' starIcon={'next'} 
                    action={{isCompHeader:1, containerKey: "popup", successBehaviour: "redirect"}}
                    className={'uiContentCenter uiButtonAppText2'} text="Document Actions" />
                <FormButton formObject={formObject} headerKey="menu"
                    rowKey="" starIcon={'adds'} tooltip='Create New'
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    customWrapper="div"
                    action={{ actionId: "new", isCompHeader:1, actionMessage: "PleaseWait", paramName: "addNew", containerKey:"redirect" }}
                    disableToHide={true}
                    className="" text="Create New: Blank" />
                <FormButton formObject={formObject} headerKey="menu" 
                    rowKey="" starIcon={'create'} tooltip='Create Copy'
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    customWrapper="div"
                    disableToHide={true}
                    action={{ actionId: "import", actionMessage: "PleaseWait", isCompHeader:1,  
                            paramName: "createDuplicate", containerKey: "redirect",
                            actionParam: {tdtId:"#docTypeID", imdtId:"#docTypeID", is:3, imdocId:"#docID"}}}
                    className="" text="Create New: Copy This" />
                <FormButton formObject={formObject} ksc="search" headerKey="menu"  
                    rowKey="" starIcon={'search'} tooltip='Search'
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                    customWrapper="div"
                    action={{ actionId: "search", actionMessage: "PleaseWait", isCompHeader:1, paramName: "search"}}
                    disableToHide={true}
                    className="" 
                    text="Search"
                    >
                </FormButton>
            </div>
        </div>
    )
}

export default withView(DocCompHeader,'', '', 0);
